import React, { useState, useEffect } from "react";

import { getUsersByPhone, createBusiness } from "../../utils/ParserUtilities";
import { getBase64 } from "../../utils/image";
import MainModal from "./MainModal";
import Button from "../button/Button";
import { Input } from "jobin-ui-components";
import { useStateValue } from "../../state/context";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng
} from "react-places-autocomplete";
import { SearchBar } from "jobin-ui-components";

import '../../styles/modal/new-business-modal.css';

const NewBusinessModal = ({ isVisible, onClose, refreshSearch }) => {
    const [{ agent }] = useStateValue();

    const [loading, setLoading] = useState(false);
    const [businessName, setbusinessName] = useState(null)
    const [name, setName] = useState(null)
    const [email, setEmail] = useState(null)
    const [phone, setPhone] = useState(null)
    const [user, setUser] = useState(null)
    const [level, setLevel] = useState(null)
    const [map, setMap] = useState(null)
    const [addressSelected, setAddressSelected] = useState(null)
    const [coordinates, setCoordinates] = useState(null)
    const [logo, setlogo] = useState(null)
    const [landingLogo, setLandingLogo] = useState(null)
    const [userPhoneError, setUserPhoneError] = useState(false);
    const [userEmailError, setUserEmailError] = useState(false);
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(true);


    const [listUser, setListUser] = useState([])
    const [userSearch, setUserSearch] = useState(null)
    const [levels, setLevels] = useState([1, 2, 3, 4, 5, 6])


    useEffect(() => {
        if (userSearch?.length > 0) {
            getUsers(userSearch)
        } else {
            setListUser([])
        }
    }, [userSearch])

    useEffect(() => {
        if (businessName && name && email && phone && level && addressSelected && coordinates && logo && landingLogo) {
            setSaveBtnDisabled(false);
        }
    }, [businessName,
        name,
        email,
        phone,
        level,
        addressSelected,
        coordinates,
        logo,
        landingLogo]);

    const getUsers = async (userPhone) => {
        let results = await getUsersByPhone({ phone: userPhone, agentId: agent.agentId })
        if (typeof results != "string") {
            setListUser(results)
        }
    }
    const handleUserEmail = input => {
        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]{2,4}$/.test(input)) {
            setEmail(input);
            setUserEmailError(false);
        } else {
            setEmail(null);
            setUserEmailError(true);
            setSaveBtnDisabled(true);
        }
    };
    const handleClientPhone = async (phone, reason) => {
        phone = phone.match(/(\+)/) ? phone : `+34${phone}`
        if (phone.length > 4 && /^\+(\d)/.test(phone)) {
            switch (reason) {
                case "businessPhone":
                    setPhone(phone)
                    break;
                case "searchPhone":
                    setUserSearch(phone)
                    break;
            }
        } else if (phone) {
            setListUser([])
        } else {
            if (reason == "businessPhone") {
                setUserPhoneError(true)
            }
        }
    }
    const handleCreateBusiness = async () => {
        setLoading(true);

        try {
            let data = {
                businessName: businessName,
                name: name,
                email: email,
                phone: phone,
                user: user?.id ?? null,
                level: level,
                addressSelected: addressSelected,
                coordinates: coordinates,
                logo: logo,
                landingLogo: landingLogo,
                agentId:agent.agentId
            }
            let result = await createBusiness(data)
            if (result) {
                refreshSearch()
                onClose()
            }
        } catch (error) {
            console.error(error)
            setLoading(false)
        }

    }
    const handlePhotos = async (file, reason) => {
        file = [...file].pop()
        switch (reason) {
            case "logo":
                setlogo(await getBase64(file))
                break;
            case "landingLogo":
                setLandingLogo(await getBase64(file) )
                break;

            default:
                break;
        }
    }
    const removePhotos = async (reason) => {
        switch (reason) {
            case "logo":
                setLogo(null)
                break;
            case "landingLogo":
                setLandingLogo(null)
                break;

            default:
                break;
        }
    }
    const handleChange = address => {
        setMap(address);
        setAddressSelected(false);

    };
    const handleSelect = async address => {
        try {
            let results = await geocodeByAddress(address);
            results = results.pop()

            const latLng = await getLatLng(results);

            setCoordinates(
                {
                    lat: latLng.lat,
                    lng: latLng.lng
                }
            )
            setAddressSelected(results.formatted_address)
        } catch (error) {
            setError(error);
        }
    };

    const searchOptions = {
        types: ["address"],
        componentRestrictions: { country: ["es"] }
    };

    return (
        <MainModal
            title={"Nuevo negocio"}
            subtitle={""}
            isVisible={isVisible}
            onClose={onClose}
            big={true}
            classNamesModal={{ modal: "new-business-modal" }}
        >
            <div onClick={() => setListUser(null)}>
                {/* Business name */}
                <div className="container-input">
                    <div className="input-slot triple">
                        <label className="subTitle">{"Nombre del negocio"}</label>
                        <Input
                            onChange={e => setbusinessName(e.target.value, "searchPhone")}
                            defaultValue={businessName}
                        />

                    </div>
                    <div className="input-slot triple">
                        <label className="subTitle">{"Seleccionar nivel"}</label>
                        <select
                            value={level}
                            onChange={(event) => setLevel(parseInt(event.target.value))}
                            defaultValue={undefined}
                        >
                            <option value={false}  >Selecciona un nivel</option>
                            {levels?.map((level_) => {
                                return (<option key={level_} value={level_}>{level_}</option>)
                            })}

                        </select>

                    </div>

                </div>
                {/* name,tel, email */}
                <div className="container-input">
                    <div className={"input-slot triple active"}>
                        <label className="subTitle">{"Teléfono de contacto"}</label>
                        <Input
                            badInput={userPhoneError}
                            onChange={e => handleClientPhone(e.target.value, "businessPhone")}
                            defaultValue={phone}
                        />
                        <span className={userPhoneError ? "error" : " error hidden"}>
                            Número de teléfono inválido.
                        </span>
                    </div>
                    <div className={"input-slot triple active"}>
                        <label className="subTitle">{"Nombre del contacto"}</label>
                        <Input
                            onChange={e => setName(e.target.value)}
                            defaultValue={name}
                        />
                    </div>
                    <div className={"input-slot triple active"}>
                        <label className="subTitle">{"Correo de contacto"}</label>

                        <Input
                            style={{ display: "flex" }}
                            badInput={userEmailError}
                            onChange={e => handleUserEmail(e.target.value)}
                            defaultValue={email}
                        />
                        <span className={userEmailError ? "error" : " error hidden"}>
                            Correo electrónico inválido.
                        </span>
                    </div>

                </div>
                {/* user selector */}
                {!user && (<div className="container-input">
                    <div className="input-slot unique p-relative">
                        <label className="subTitle">{"Teléfono del usuario asociado a este negocio"}</label>
                        <Input
                            onFocus={() => getUsers(userSearch)}
                            badInput={userPhoneError}
                            onChange={e => handleClientPhone(e.target.value, "searchPhone")}
                            defaultValue={userSearch}
                        />
                        <div className={listUser?.length > 0 ? "userWrapper active" : "userWrapper"}>
                            {listUser?.map((user_) => (
                                (<div key={user_.id} onClick={() => { setUser(user_); setListUser(null) }}>
                                    <img src={user_?.get("UserPic")?.url()} alt="foto perfil" />
                                    <span>{user_?.get("Name")}</span>
                                    <span>{user_.get("Phone")}</span>
                                </div>)
                            ))}
                        </div>
                    </div>

                </div>)}
                {/* user selected */}
                {user && (<div className="container-input">
                    <div className="input-slot unique ">
                        <label className="subTitle">{"Usuario seleccionado."}</label>

                        <div className="user-selected" onClick={() => { setUser(null); setUserSearch(null) }}>
                            <img src={user?.get("UserPic")?.url()} alt="foto perfil" />
                            <span>{user?.get("Name")}</span>
                            <span>{user?.get("Phone")}</span>
                            <span></span>
                        </div>
                    </div>

                </div>)}
                {/* map */}
                {!addressSelected && (<div className="container-input">
                    <div className="input-slot unique">
                        <label className="subTitle">{"Dirección del negocio"}</label>
                        <PlacesAutocomplete
                            value={map}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            searchOptions={searchOptions}
                            style={{ marginTop: 0 }}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div className="p-relative search-address">
                                    <SearchBar
                                        {...getInputProps({ placeholder: "Dirección exacta con número" })}
                                    />
                                    <div
                                        className={suggestions.length > 0
                                            ? "autocomplete-dropdown-container ready"
                                            : "autocomplete-dropdown-container"
                                        }
                                    >
                                        {loading && <div>Cargando...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? "suggestion-item active"
                                                : "suggestion-item";
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(
                                                        suggestion,
                                                        {
                                                            className
                                                        }
                                                    )}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                </div>)}
                {addressSelected && (<div className="container-input">
                    <div className="input-slot unique" >
                        <label className="subTitle">{"Dirección seleccionada"}</label>
                        <p className="addres-selected" onClick={() => { setAddressSelected(null); setMap(null) }}>{addressSelected}</p>
                    </div>
                </div>)}
                {/* logo and landing logo */}
                <div className="container-input">
                    <div className="input-slot triple photos">
                        <label htmlFor="logo" className="add-photos">Adjuntar logo para la web del negocio</label>
                        <input type="file" id="logo" accept="image/jpeg, image/png" onChange={(event) => handlePhotos(event.target.files, "logo")} />
                        <div className="photo-container">
                            {logo && (<img
                                className="photo"
                                src={logo.base64}
                                alt="photo" onClick={() => removePhotos("logo")}
                            />)}
                        </div>
                    </div>
                    <div className="input-slot triple photos">
                        <label htmlFor="landing" className="add-photos">Adjuntar logo del negocio</label>
                        <input type="file" id="landing" accept="image/jpeg, image/png" onChange={(event) => handlePhotos(event.target.files, "landingLogo")} />
                        <div className="photo-container">
                            {landingLogo && (<img
                                className="photo"
                                src={landingLogo.base64}
                                alt="photo" onClick={() => removePhotos("landingLogo")}
                            />)}
                        </div>
                    </div>
                </div>

            </div>


            <Button
                style={{ margin: " 16px auto 0" }}
                disabled={saveBtnDisabled}
                buttonText="Crear"
                onClick={handleCreateBusiness}
                loading={loading}
            />

        </MainModal>
    );
};

export default NewBusinessModal;